export type DocumentExportWarningCounts = {
	readonly notAddressed: number;
	readonly remaining: number;
};

/**
 * One line per non-zero count, singular/plural agreed — a count at zero contributes no line rather
 * than a "0 information…" sentence nobody needs to read. Only the not-addressed and to-verify counts
 * decide what is shown; the document's validation status never does.
 */
const resolveDocumentExportWarningLines = ({
	notAddressed,
	remaining,
}: DocumentExportWarningCounts): readonly string[] => {
	const lines: string[] = [];

	if (notAddressed === 1) {
		lines.push('1 information non abordée partira vide.');
	} else if (notAddressed > 1) {
		lines.push(`${notAddressed} informations non abordées partiront vides.`);
	}

	if (remaining === 1) {
		lines.push('1 information est à vérifier.');
	} else if (remaining > 1) {
		lines.push(`${remaining} informations sont à vérifier.`);
	}

	return lines;
};

export default resolveDocumentExportWarningLines;
